import { TouchableOpacity, type ViewProps } from 'react-native';

import { BrandColors } from '@/constants/theme';
import { useAuth } from '@/contexts/auth-context';
import { showAlert } from '@/lib/alert';
import authService from '@/lib/auth';
import { getRoleLabel, isCustomerRole } from '@/lib/roles';
import { router } from 'expo-router';
import { StyleSheet } from 'react-native';
import { ThemedText } from './themed-text';
import { useAuthStore } from '@/stores/use-auth-store';

export type SwitchModeProps = ViewProps & {
  style?: ViewProps['style'];
  isText?: boolean;
};

export function SwitchMode({ style, isText = false }: SwitchModeProps) {
  const { user, setUser } = useAuth();
  const setActiveBooking = useAuthStore((state) => state.setActiveBooking);

  if (!user?.driver?.is_verified || user.role === 'customer') {
    return null;
  } 

  const handleSwitchRole = async () => {
    const roleLabel = isCustomerRole(user?.role) ? 'driver' : 'business_customer';
    const newRole = getRoleLabel(roleLabel);

    showAlert(
      "Switch Role",
      `Switch to ${newRole} mode?`,
      [
        {
          text: "Cancel",
          style: "cancel",
        },
        {
          text: "Switch",
          onPress: async () => {
            try {
              const { user: switched } = await authService.switchRole();
              setUser(switched);
              setActiveBooking(null);
              router.push("/");
              showAlert("Success", `Switched to ${newRole} mode successfully`);
            } catch (error) {
              console.error("Error switching role:", error);
              showAlert("Error", "Failed to switch role. Please try again.");
            }
          },
        },
      ]
    );
  };
  return <TouchableOpacity
    style={[styles.container, style]}
    onPress={handleSwitchRole}
    activeOpacity={0.8}
  >
    <ThemedText style={styles.roleText}>{isText && "Go to"} <ThemedText style={[styles.roleText, { textTransform: isText ? "lowercase" : "none" }]}>{isCustomerRole(user?.role) ? "Driver mode" : "Customer mode"}</ThemedText></ThemedText>
  </TouchableOpacity>;
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: BrandColors.primary,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 12,
  },
  roleText: {
    fontSize: 16,
    fontWeight: "600",
    color: BrandColors.white,
  },
});
